import React, { useEffect } from 'react';
import useEmailConfirmation from '../hooks/user/useEmailConfirmation';
import UserFeedback from '../components/UserFeedback';
import { isHttpError } from '../components/chat/ChatLayout';
import PageContainer from '../components/ibok-core/module/PageContainer';
import './ConfirmEmailPage.less';
var getConfirmationCode = function (pathname) { return pathname
    .replace('/bekreft_epost/', ''); };
var ActivationError = function (_a) {
    var error = _a.error;
    var defaultErrorTitle = 'Klarte ikke å aktivere kontoen din';
    if (!isHttpError(error)) {
        return React.createElement(UserFeedback, { status: "error" },
            React.createElement("p", null,
                React.createElement("strong", null, defaultErrorTitle)),
            React.createElement("p", null, "En ukjent feil har oppst\u00E5tt. Pr\u00F8v gjerne p\u00E5 nytt om litt, da det kan v\u00E6re et midlertidig problem. Skulle problemet vedvare kan du ta kontakt med oss p\u00E5 brukerst\u00F8tte."));
    }
    // The API provides human friendly error messages,
    // Use them, when available
    var _b = error.data, detail = _b.detail, title = _b.title;
    var humanTitle = title || defaultErrorTitle;
    return React.createElement(UserFeedback, { status: "info" },
        React.createElement("p", null,
            React.createElement("strong", null, humanTitle)),
        React.createElement("p", null, detail));
};
var ConfirmEmailPage = function () {
    var confirmationCode = getConfirmationCode(window.location.pathname);
    var _a = useEmailConfirmation(), confirmEmail = _a.confirmEmail, error = _a.error, isConfirmed = _a.isConfirmed;
    useEffect(function () {
        confirmEmail(confirmationCode);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmationCode]);
    // Automatically redirect the user to the login page after
    // successful confirmation
    useEffect(function () {
        if (!isConfirmed) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return function () { };
        }
        var timeout = setTimeout(function () {
            window.location.href = '/logg_inn';
        }, 1500);
        return function () { return clearTimeout(timeout); };
    }, [isConfirmed]);
    var isConfirming = !isConfirmed && !error;
    return React.createElement(React.Fragment, null,
        React.createElement(PageContainer, null,
            React.createElement("div", { className: "confirmemailheader" },
                isConfirmed
                    ? React.createElement("i", { className: "fas fa-check-circle" })
                    : React.createElement("i", { className: "fas fa-envelope-open-text" }),
                React.createElement("h1", null,
                    isConfirming && 'Aktiverer konto',
                    isConfirmed && 'Kontoen din har blitt aktivert!',
                    error && 'Kunne ikke aktivere kontoen din')),
            isConfirming && React.createElement(UserFeedback, { status: "info", showIcon: true },
                React.createElement("p", null, "Verifiserer e-postadressen og aktiverer brukaren din")),
            isConfirmed && React.createElement(UserFeedback, { status: "success" },
                React.createElement("p", null, "Kontoen er aktivert! Du kan n\u00E5 logge inn p\u00E5 iBok"),
                React.createElement("a", { href: "/logg_inn" }, "G\u00E5 til Logg inn")),
            error && React.createElement(ActivationError, { error: error })));
};
export default ConfirmEmailPage;
